import { settings } from "../libs/api-url";
import axios from "@/libs/axios";

class SettingsService {
  /**
   * Fetches the site configuration settings.
   *
   * @returns {Promise<Object>} The response data containing configuration settings.
   * @throws {Error} If the request fails, the error is thrown for the caller to handle.
   */
  static getConfiguration() {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await axios.get(settings.getConfiguration);
        resolve(data.data);
      } catch (err) {
        console.error('SettingsService.getConfiguration error:', err);
        reject(err);
      }
    });
  }

  /**
   * Updates the site configuration settings.
   * Uses FormData for file uploads and mixed data.
   *
   * @param {Object} request - The configuration data to be updated.
   * @returns {Promise<Object>} The response data after updating configuration.
   * @throws {Error} If the request fails, the error is rejected for the caller to handle.
   */
  static updateConfiguration(request) {
    return new Promise(async (resolve, reject) => {
      try {
        
        // Create FormData for file uploads and mixed data
        const formData = new FormData();
        
        // Add all form fields to FormData
        Object.keys(request).forEach(key => {
          const value = request[key];
          
          // Handle file objects vs string values
          if (value instanceof File) {
            formData.append(key, value);
          } else if (value !== null && value !== undefined && value !== '') {
            formData.append(key, value);
          }
        });

        for (let [key, value] of formData.entries()) {
        }

        const data = await axios.post(settings.updateConfiguration, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        resolve(data.data);
      } catch (err) {
        console.error('API error:', err);
        reject(err);
      }
    });
  }

  /**
   * Fetches the list of countries.
   *
   * @returns {Promise<Object>} The response data containing country list.
   * @throws {Error} If the request fails, the error is thrown for the caller to handle.
   */
  static async getCountry() {
    try {
      const response = await axios.get(settings.getCountry);
      return response.data;
    } catch (err) {
      throw err;
    }
  }
}

export { SettingsService };
